<template>
   <form @submit.prevent="validate('userpassword')" data-vv-scope="userpassword" class="">
      <div class="account__block__title mb-3">{{ t('user.page.data.account') }}</div>
      <form-message :messages="getMessage( 'userpassword')"></form-message>
      <div class="row">
         <!-- PASSWORD -->
         <div class="col-12 form-group required">
            <!--<label for="userdata__password" class="account__block__label">{{ t('userdata.password') }}</label>-->
            <input
                :disabled="isPwLoading"
                v-model="form.password.p0"
                v-validate="'required'"
                :class="validClasses('userpassword.passwordOld')"
                name="passwordOld"
                type="password"
                class="form-control"
                id="userdata__password_old"

                :placeholder="t('userdata.passwordOld')"
                :data-vv-as="t('userdata.passwordOld')"
            >
            <div v-if="isInValid('userpassword.passwordOld')" class="invalid-feedback">
               {{ errors.first('userpassword.passwordOld') }}
            </div>
         </div>
         <div class="col-12 form-group required">
            <!--<label for="userdata__password" class="account__block__label">{{ t('userdata.password') }}</label>-->
            <input
                :disabled="isPwLoading"
                v-model="form.password.p1"
                v-validate="form.password.validity1"
                :class="validClasses('userpassword.passwordNew')"
                name="passwordNew"
                type="password"
                :ref="'passwordNew'"
                class="form-control"
                id="userdata__password"
                :placeholder="t('userdata.password')"
                :data-vv-as="t('userdata.password')"
            >
            <!---->
            <div v-if="isInValid('userpassword.passwordNew')" class="invalid-feedback">
               {{ errors.first('userpassword.passwordNew') }}
            </div>
         </div>
         <div class="col-12 form-group required">
            <!--<label for="userdata__passwordConfirm" class="account__block__label">{{
              t('userdata.passwordConfirm') }}</label>-->
            <input
                :disabled="isPwLoading"
                v-model="form.password.p2"
                v-validate="form.password.validity2"
                :class="validClasses('userpassword.passwordConfirm')"
                name="passwordConfirm"
                type="password"
                class="form-control"
                id="userdata__passwordConfirm"
                :placeholder="t('userdata.passwordConfirm')"
                :data-vv-as="t('userdata.passwordConfirm')"
            >
            <div v-if="isInValid('userpassword.passwordConfirm')"
                class="invalid-feedback">
               {{ errors.first('userpassword.passwordConfirm') }}
            </div>
         </div>
         <div class="col-12">
            <div class="form-text text-muted field__legend mb-3"
                v-html="t('register.passwordHint')">

            </div>
         </div>
      </div>
      <div class="row mt-4" v-if="isSubmit('userpassword')">
         <div class="col-12 d-flex justify-content-end">
            <button :disabled="isPwLoading" class="btn btn-primary btn-sm" type="submit">
               {{ t('general.btn.submit') }}
            </button>
         </div>
      </div>
   </form>
</template>

<script>
import Vuex from 'vuex';

import {regex} from "@/config";
import {mixins} from "@/components/user/UserData/user_helpers";
import VeeInput from "@/components/ValidateInput";
import FormMessage from "@/components/parts/form-message";

export default {
   name: "password",
   mixins:[mixins],
   components: {
      VeeInput,
      FormMessage,

   },
   data() {
      return {

         loading: [],


         form: {

            password: {
               p0: '',
               p1: '',
               p2: '',
               validity1: {
                  required: true,
                  min: 6,
                  regex: regex.password
               },
               validity2: {
                  required: true,
                  min: 6,
                  confirmed: 'passwordNew'
               }
            }
         }
      }
   },
   computed:{
      ...Vuex.mapState([
         'lang',
         'loaderList'
      ]),
      isPwLoading() {
         return this.loaderList.some(item => item === 'userDataPwChange');
      },
   },

   methods:{
      validate(scope) {
         this.$validator.validateAll(scope).then((result) => {

            if (result) {
               this.deleteMessage(scope);
               this.updatePassword();
            }


         });
      },
      updatePassword() {


         if (this.form.password.p1 === this.form.password.p2) {
            //Show loading bar
            this.$store.commit('addLoad', 'userpassword');

            //Push to vuex new data values to send it to REST
            this.$store.dispatch('saveUserData', {
               'old_password': this.form.password.p0,
               'new_password': this.form.password.p1,
               'new_password_confirmation': this.form.password.p2
            }).then((responce) => {

               //Finish load bar
               this.$store.commit('endLoad', 'userpassword');

               //Error handling
               if (responce.data.status === 'SUCCESS') {

                  //Show message that all successfully changed
                  this.addMessage({
                     scope: 'userpassword',
                     state: 'success',
                     text: this.t('user.data.pw.change.success')
                  });

                  //Show message that some error has occurred
                  this.form.password.p0 = '';
                  this.form.password.p1 = '';
                  this.form.password.p2 = '';
                  setTimeout(() => {
                     this.errors.clear('userpassword');
                  }, 50);
               } else {
                  let msg;
                  if (typeof responce.data.error !== 'undefined') {
                     msg = this.t('userdata.error.' + responce.data.error.code);
                  } else {
                     msg = responce.data.message
                  }
                  this.addMessage({
                     scope: 'userpassword',
                     state: 'danger',
                     text: msg
                  });
               }

            })
         } else {
            this.addMessage({
               scope: 'userpassword',
               state: 'warning',
               text: this.t('user.data.pw.confirm.notsame')
            });
         }
      },
   }
}
</script>

<style scoped>

</style>
